"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractorColumnFullWidthProps = exports.contractorColumnProps = exports.contractorTypes = void 0;
const constants_1 = require("utils/constants");
exports.contractorTypes = {
    SET_DATA_GRID: 'CONTRACTOR TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'CONTRACTOR TYPES ON PAGE CHANGE',
    ON_FILTER_CHANGE: 'CONTRACTOR TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'CONTRACTOR TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'CONTRACTOR TYPES ON MUTATION',
    ON_CHANGE_DATAITEM: 'CONTRACTOR TYPES ON CHANGE DATAITEM',
    ON_SAVE_DATAITEM: 'CONTRACTOR TYPES ON SAVE DATAITEM',
    SET_DATA_ENUM: 'CONTRACTOR TYPES GET DATA ENUM',
    ON_DELETE_DATAITEM: 'CONTRACTOR TYPES ON DELETE DATAITEM',
    SET_ERROR: 'CONTRACTOR TYPES SET ERROR',
    SET_LOADING: 'CONTRACTOR TYPES SET LOADING'
};
exports.contractorColumnProps = [
    {
        show: true,
        field: 'url',
        title: 'Contractor Logo',
        width: '180px',
        filterable: false
    },
    {
        show: true,
        field: 'contractor_code',
        title: 'Contractor Code',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor Name',
        width: '330px',
        filter: 'text'
    },
    {
        show: true,
        field: 'contractor_type',
        title: 'Contractor Type',
        width: '200px',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.contractorColumnFullWidthProps = [
    ...exports.contractorColumnProps
];
exports.contractorColumnFullWidthProps[0] = {
    show: true,
    field: 'url',
    title: 'Contractor Logo',
    width: '180px',
    filterable: false
};
